import React from 'react';
import { Box, Checkbox as MuiCheckbox, CheckboxProps, SxProps, Theme } from '@mui/material';
import { Minus, Rectangle, Check } from '@assets/svgs';
import { checkedIconStyle } from './Checkbox.styles';

const IndeterminateCheckedIcon = () => (
  <Box
    data-testid='indeterminateChecked-icon'
    sx={{
      ...checkedIconStyle,
      fill: ({ palette }: Theme) => palette.icon.main,
      stroke: ({ palette }: Theme) => palette.icon.main,
      color: ({ palette }: Theme) => palette.icon.main,
      backgroundColor: ({ palette }: Theme) => palette.background.secondary,
    }}
  >
    <Minus width='10px' height='10px' />
  </Box>
);

const CheckedIcon = ({ disabled }: ICheckbox) => {
  return (
    <Box
      data-testid='checked-icon'
      sx={{
        ...checkedIconStyle,
        color: ({ palette }: Theme) => (disabled ? `${palette.common.white}60` : palette.icon.main),
        backgroundColor: ({ palette }: Theme) => (disabled ? palette.text.disabled : palette.background.secondary),
      }}
    >
      <Check width='10px' height='10px' />
    </Box>
  );
};

function Icon({ disabled, hasError }: ICheckbox) {
  return (
    <Box
      sx={{
        ...checkedIconStyle,
        color: ({ palette }: Theme) => (disabled ? palette.icon.disabled : palette.background.paper),
        backgroundColor: disabled ? 'transparent' : null,
        stroke: ({ palette }: Theme) =>
          disabled ? palette.text.disabled : hasError ? palette.other.error : palette.text.subdued,
        '& .MuiCheckbox-indeterminate': {
          color: ({ palette }: Theme) => palette.background.paper,
          '&.Mui-checked': {
            color: ({ palette }: Theme) => palette.background.paper,
          },
        },
      }}
    >
      <Rectangle />
    </Box>
  );
}

interface ICheckbox extends CheckboxProps {
  sxProps?: SxProps;
  hasError?: boolean;
}

export const Checkbox = ({ checked, disabled, indeterminate, sxProps, hasError, ...other }: ICheckbox) => {
  return (
    <MuiCheckbox
      icon={<Icon disabled={disabled} hasError={!!hasError} />}
      checkedIcon={<CheckedIcon disabled={disabled} />}
      checked={checked}
      disabled={disabled}
      disableRipple={false}
      indeterminateIcon={indeterminate && checked ? <IndeterminateCheckedIcon /> : <Rectangle />}
      indeterminate={indeterminate}
      sx={{
        backgroundColor: ({ palette }: Theme) => palette.background.paper,
        color: ({ palette }: Theme) => palette.background.paper,
        stroke: ({ palette }: Theme) => (disabled ? `${palette.common.white}60` : palette.text.subdued),
        ...sxProps,
      }}
      {...other}
    />
  );
};
